import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import Chart from "chart.js";
import Chartkick from "vue-chartkick";
import ChartDataLabels from "chartjs-plugin-datalabels";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { apiClient } from "@/services/ApiService.js";
import VueSweetalert2 from "vue-sweetalert2";
import swal from "sweetalert2/dist/sweetalert2.all.min.js";
import moment from 'moment';

Vue.config.productionTip = false;
Vue.use(VueSweetalert2);

Vue.use(Chartkick.use(Chart));
Chart.plugins.unregister(ChartDataLabels);
Chart.plugins.register(ChartDataLabels);

Chart.plugins.register({
  beforeInit(chart) {
    // nada
  },
  afterLayout(chart) {
    const lp = (chart.options && chart.options.legendPadding) || null;
    const legend = chart.legend;
    if (!lp || !legend || legend.height === undefined) return;

    // empuja la leyenda por lados independientes
    // valores por defecto si faltan
    const top    = Number(lp.top    || 0);
    const right  = Number(lp.right  || 0);
    const bottom = Number(lp.bottom || 0);
    const left   = Number(lp.left   || 0);

    // ajusta las medidas/posicion de la leyenda
    legend.top    += top;
    legend.left   += left;
    legend.right  += right;
    legend.bottom += bottom;
    legend.height += (top + bottom);
    legend.width  += (left + right);

    // Tambien empuja el chartArea si la leyenda está “top”
    // para que no se encime con el pastel
    // (Chart.js ya re-layout, pero esto ayuda a asegurar separacion)
    if (chart.chartArea) {
      chart.chartArea.top += top;
      chart.chartArea.left += left;
      chart.chartArea.right -= right;
      chart.chartArea.bottom -= bottom;
    }
  }
});

// CONFIG. GRAFICA DE PASTEL / Lineas guia desde la rebanada hacia la etiqueta externa
// Chart.plugins.register({
//   // despues de dibujar el dataset, trazamos las lineas
//   afterDatasetDraw(chart, args, opts) {
//     const meta = chart.getDatasetMeta(0);
//     if (!meta || meta.hidden) return;
//     const ctx = chart.ctx;
//     const arcs = meta.data;

//     ctx.save();
//     ctx.strokeStyle = opts.color || '#9b9b9bff';
//     ctx.lineWidth = 1;

//     arcs.forEach(arc => {
//       const m = arc._model; // Chart 2
//       const angle = (m.startAngle + m.endAngle) / 2;
//       const sx = m.x + Math.cos(angle) * m.outerRadius; // borde del slice
//       const sy = m.y + Math.sin(angle) * m.outerRadius;

//       // punto hacia afuera (ligeramente)
//       const ex = m.x + Math.cos(angle) * (m.outerRadius + 16);
//       const ey = m.y + Math.sin(angle) * (m.outerRadius + 16);

//       // pequeño segmento horizontal al final (tipo “callout”)
//       const hx = ex + (Math.cos(angle) >= 0 ? 12 : -12);

//       ctx.beginPath();
//       ctx.moveTo(sx, sy);
//       ctx.lineTo(ex, ey);
//       ctx.lineTo(hx, ey);
//       ctx.stroke();
//     });
//     ctx.restore();
//   }
// });

const token = localStorage.getItem("token");
if (token) {
  apiClient.defaults.headers.common["Authorization"] = "Bearer " + token;
}
//else {
//apiClient.defaults.headers["Content-Type"] =
//  "application/x-www-form-urlencoded";
//}

apiClient.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    // Si no hay response (error de red, timeout, servidor caído)
    if (!error.response) {
      return Promise.reject(error);
    }

    let originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.commit("SET_LOADING", false);
      store.commit("AUTH_LOGOUT");

      // Mostrar mensaje solo si el usuario estaba autenticado (tenía token)
      const Swal = require('sweetalert2');
      Swal.fire({
        icon: 'warning',
        title: 'Sesión expirada',
        text: 'Tu sesión ha expirado. Inicia sesión nuevamente.',
        confirmButtonText: 'Ir al login',
        confirmButtonColor: '#AF8936',
        allowOutsideClick: false,
      }).then(() => {
        router.push("/login");
      });

      // No propagar el error al .catch del componente
      return new Promise(() => {});
    }

    if (error.response.status === 404 && !originalRequest._retry) {
      originalRequest._retry = true;
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD MMM YYYY h:mm A')
    }
});
moment.locale('es-mx');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
